import React from "react";
import { EnvelopeSimple, GearSix, GenderFemale, GenderMale, GenderTransgender, InstagramLogo, MapPinLine, Phone, SquaresFour, Tag, TiktokLogo, UserCircle, UserList, Users, UsersFour, YoutubeLogo, ChatTeardropText, Megaphone } from "@phosphor-icons/react";
import { PAGE_PERMISSIONS } from "../enums/permissions/permission";
const {
  CAN_VIEW_ADMIN_OVERVIEW_PAGE,
  CAN_VIEW_COLLAB_CREATORS_PAGE,
  CAN_VIEW_ADMIN_COLLAB_REQUESTS_PAGE,
  CAN_VIEW_TAG_MANAGEMENT_PAGE,
  CAN_VIEW_USERS_PAGE,
  CAN_VIEW_SETTINGS_PAGE,
  CAN_VIEW_CREATOR_OVERVIEW_PAGE,
  CAN_VIEW_EDIT_PROFILE_PAGE,
  CAN_VIEW_EDIT_CONTACT_PAGE,
  CAN_VIEW_CREATOR_COLLAB_REQUESTS_PAGE,
  CAN_VIEW_BROADCAST_MESSAGES_PAGE,
  CAN_VIEW_INVITE_REQUESTS_PAGE,
  CAN_VIEW_ALL_CHATS,
  CAN_VIEW_CHATS_PAGE,
} = PAGE_PERMISSIONS;

export const FILTER_LIST = Object.freeze([
  {
    filterKey: 'Collab',
    title: 'All',
    icon: <SquaresFour size={24} />,
    permission: '',
  },
  {
    filterKey: 'Location',
    title: 'Location',
    icon: <MapPinLine size={24} />,
    permission: '',
  },
  {
    filterKey: 'OnlyFans',
    title: 'OnlyFans',
    icon: null,
    permission: ''
  },
  {
    filterKey: 'OnlyFansTV',
    title: 'OnlyFansTV',
    icon: null,
    permission: ''
  },
  {
    filterKey: 'MyFreeCams',
    title: 'MyFreeCams',
    icon: null,
    permission: ''
  },
  {
    filterKey: 'Manyvids',
    title: 'Manyvids',
    icon: null,
    permission: ''
  },
  {
    filterKey: 'Chaturbate',
    title: 'Chaturbate',
    icon: null,
    permission: ''
  },
  {
    filterKey: 'Women',
    title: 'Women',
    icon: <GenderFemale size={24} />,
    permission: ''
  },
  {
    filterKey: 'Men',
    title: 'Men',
    icon: <GenderMale size={24} />,
    permission: ''
  },
  {
    filterKey: 'Trans',
    title: 'Trans',
    icon: <GenderTransgender size={24} />,
    permission: ''
  },
  {
    filterKey: 'Instagram',
    title: 'Instagram',
    icon: <InstagramLogo size={24} />,
    permission: ''
  },
  {
    filterKey: 'Tiktok',
    title: 'Tiktok',
    icon: <TiktokLogo size={24} />,
    permission: ''
  },
  {
    filterKey: 'Youtube',
    title: 'Youtube',
    icon: <YoutubeLogo size={24} />,
    permission: ''
  }
]);

export const PAGE_LIST = Object.freeze([
  {
    title: 'Overview',
    icon: <SquaresFour size={24} />,
    permission: CAN_VIEW_ADMIN_OVERVIEW_PAGE,
    path: '/admin'
  },
  {
    title: 'Overview',
    icon: <SquaresFour size={24} />,
    permission: CAN_VIEW_CREATOR_OVERVIEW_PAGE,
    path: '/overview'
  },
  {
    title: 'Edit Profile',
    icon: <UserCircle size={24} />,
    permission: CAN_VIEW_EDIT_PROFILE_PAGE,
    path: '/edit-profile'
  },
  // {
  //   title: 'Edit Contact',
  //   icon: <Phone size={24} />,
  //   permission: CAN_VIEW_EDIT_CONTACT_PAGE,
  //   path: '/edit-contact'
  // },
  {
    title: 'Collab Creators',
    icon: <UsersFour size={24} />,
    permission: CAN_VIEW_COLLAB_CREATORS_PAGE,
    path: '/admin-collab-creators'
  },
  {
    title: 'Collab Requests',
    icon: <EnvelopeSimple size={24} />,
    permission: CAN_VIEW_ADMIN_COLLAB_REQUESTS_PAGE,
    path: '/admin-collab-requests'
  },
  {
    title: 'Broadcast',
    icon: <Megaphone size={24} />,
    permission: CAN_VIEW_BROADCAST_MESSAGES_PAGE,
    path: '/admin-broadcast-messages'
  },
  {
    title: 'Chats',
    icon: <ChatTeardropText size={20} />,
    permission: CAN_VIEW_CHATS_PAGE,
    path: '/chats'
  },
  {
    title: 'Collab Chats',
    icon: <ChatTeardropText size={20} />,
    permission: CAN_VIEW_ALL_CHATS,
    path: '/admin-chats'
  },
  {
    title: 'Collab Requests',
    icon: <Users size={24} />,
    permission: CAN_VIEW_CREATOR_COLLAB_REQUESTS_PAGE,
    path: '/collab-requests'
  },
  {
    title: 'Invite Requests',
    icon: <EnvelopeSimple size={24} />,
    permission: CAN_VIEW_INVITE_REQUESTS_PAGE,
    path: '/invite-requests'
  },
  {
    title: 'Tag Management',
    icon: <Tag size={24} />,
    permission: CAN_VIEW_TAG_MANAGEMENT_PAGE,
    path: '/tag-management'
  },
  {
    title: 'Users',
    icon: <UserList size={24} />,
    permission: CAN_VIEW_USERS_PAGE,
    path: '/users'
  },
  // {
  //   title: 'Activity Log',
  //   icon: <NotePencil  size={24} />,
  //   permission: CAN_VIEW_SETTINGS_PAGE,
  //   path: '/activity-log'
  // },
  {
    title: 'Settings',
    icon: <GearSix size={24} />,
    permission: CAN_VIEW_SETTINGS_PAGE,
    path: '/settings'
  },
]);

export const GUEST_ROUTES = Object.freeze([
  '/',
  '/creator',
  '/collab-creators',
  '/contact-us',
  '/terms-and-conditions',
  '/privacy-policy',
  '/referral-program'
]);